import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";

import { ServiceUrl } from "../../utils/serviceUrl";

import Header from "../header";

const ExternalCircularView = (props) => {
  const [loader, setLoader] = useState(false);
  const [externalCircularview, setExternalCircularview] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoader(true);
    axios
      .post(ServiceUrl.MOB.LIST_EXTERNAL_CIRUCULAR + "?id=" + `${id}`)
      .then((res) => {
        if (res["data"].status == "1") {
          setExternalCircularview(res["data"].data);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  }, []);
  const styles = {
    card: {
      padding: "20px",
      marginTop: "20px",
      borderRadius: "8px",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      border: "1px solid #ddd",
    },
    header: {
      backgroundColor: "#f8f9fa",
      padding: "10px 20px",
      borderBottom: "1px solid #e0e0e0",
    },
    title: {
      fontSize: "24px",
      fontWeight: "bold",
      margin: 0,
      color: "#333",
    },
    row: {
      marginBottom: "10px",
    },
    label: {
      fontSize: "16px",
      color: "#555",
    },
    fileLink: {
      color: "#007bff",
      textDecoration: "none",
    },
  };
  return (
    <>
      <Header
        title="Internal Circular Details"
        backAction={true}
        rightActions={[]}
        onBack={() => navigate(-1)} // Go back in history when back button is clicked
      />
      <div className="container">
        {externalCircularview.map((circular, index) => (
          <Card key={index} style={styles.card}>
            <Card.Header style={styles.header}>
              <h2 style={styles.title}>{circular.circular_type}</h2>
            </Card.Header>
            <Card.Body>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Create Date :</strong> {circular.created_on}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Department :</strong> {circular.department}
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Received Date :</strong> {circular.received_date}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Send By:</strong> {circular.send_by}
                  </p>
                </Col>
              </Row>

              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Reminders To:</strong> {circular.reminders_to}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Forwarded To:</strong> {circular.forwarded_to}
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Responsible :</strong> {circular.responsible}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong> Reminder On:</strong> {circular.reminder_on}
                  </p>
                </Col>
              </Row>

              <Row style={styles.row}>
                <Col md={12}>
                  <p style={styles.label}>
                    <strong>Content: </strong>{" "}
                    <span>{circular.content || "No content available"}</span>
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={12}>
                  <p style={styles.label}>
                    <strong>Uploaded Files:</strong>{" "}
                    {circular.upload_files ? (
                      <a
                        href={circular.upload_files}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.fileLink}
                      >
                        View File
                      </a>
                    ) : (
                      "No files uploaded"
                    )}
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
      </div>
    </>
  );
};

export default ExternalCircularView;
